import {
  Button,
  Card,
  Label,
  Spinner,
  TextInput,
} from 'flowbite-react';
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { UseGlobalSetting, UseSaveGlobalSettings } from '../services/Query';
import { PulseLoader } from 'react-spinners';

type GlobalSettingFrm = {
  id: string;
  serverIp: string;
  serverPort: string;
  gameQueue: string;
};

export const GlobalSettings = () => {
  const {
    data: globalSetting,
    isLoading,
    refetch: reloadGlobalSetting,
  } = UseGlobalSetting();
  
  const { mutate: saveSetting, isLoading: isSaving } = UseSaveGlobalSettings();
  
  const {
    register,
    getValues,
    reset,
    formState: { isValid },
  } = useForm<GlobalSettingFrm>({
    mode: 'onChange',
  });

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (globalSetting) {
      reset({
        id: globalSetting.id,
        serverIp: globalSetting.serverIp,
        serverPort: globalSetting.serverPort,
        gameQueue: globalSetting.gameQueue,
      });
      setIsDirty(false);
    }
  }, [globalSetting, reset]);

  const handleInputChange = () => {
    setIsDirty(true);
  };

  const saveSettings = () => {
    const data = getValues();
    saveSetting(JSON.stringify(data), {
      onSuccess: () => {
        reloadGlobalSetting();
        setIsDirty(false);
      },
    });
  };

  if (isLoading) {
    return (
      <div className="flex justify-center w-screen py-10">
        <PulseLoader color="#36d7b7" size={15} margin={5} />
      </div>
    );
  }

  return (
    <div className="grid py-3 gap-y-3">
      <h5 className='font-bold text-xl'>Global Settings</h5>
      
      <div className="container w-[500px]">
        <Card>
          <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            Server Configuration
          </h5>
          
          <div className="flex flex-col gap-4">
            <div>
              <div className="block mb-2">
                <Label value="Server IP" htmlFor="serverIp" />
              </div>
              <TextInput
                id="serverIp"
                type="text"
                placeholder="Enter server IP address"
                {...register('serverIp', { required: true })}
                onChange={handleInputChange}
              />
            </div>
            
            <div>
              <div className="block mb-2">
                <Label value="Server Port" htmlFor="serverPort" />
              </div>
              <TextInput
                id="serverPort"
                type="text"
                placeholder="Enter server port"
                {...register('serverPort', { required: true })}
                onChange={handleInputChange}
              />
            </div>
            
            <div>
              <div className="block mb-2">
                <Label value="Game Queue" htmlFor="gameQueue" />
              </div>
              <TextInput
                id="gameQueue"
                type="text"
                placeholder="Enter game queue"
                {...register('gameQueue', { required: true })}
                onChange={handleInputChange}
              />
            </div>
            
            <div className="flex justify-end">
              <Button
                type="button"
                disabled={!isValid || !isDirty || isSaving}
                onClick={saveSettings}
              >
                {isSaving && (
                  <Spinner color="info" aria-label="saving" className="me-1" />
                )}
                Save Settings
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};